import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { TrackingEventName } from "./tracking";
import { useTrackWhishlistItem } from "./useTrackWhishlistItem";

interface TrackWhishlistItemRemovedFunctionArgs {
  readonly product: Product;
  readonly list?: string;
}

interface TrackWhishlistItemRemovedFunction {
  (args: TrackWhishlistItemRemovedFunctionArgs): void;
}

interface UseTrackWhishlistItemRemovedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackWhishlistItemRemovedFunction {
  (agrs: UseTrackWhishlistItemRemovedFunctionArgs): TrackWhishlistItemRemovedFunction;
}

const useTrackWhishlistItemRemoved: UseTrackWhishlistItemRemovedFunction = ({
  country,
  segment,
  tradename,
  userId,
}) => {
  const trackWhishlistItem = useTrackWhishlistItem({
    event: TrackingEventName.WISHLIST_ITEM_REMOVED,
    country,
    segment,
    tradename,
    userId,
  });

  const trackWhishlistItemRemoved: TrackWhishlistItemRemovedFunction = useCallback(
    ({ product, list }) => {
      trackWhishlistItem({
        product,
        list,
      });
    },
    [trackWhishlistItem],
  );

  return trackWhishlistItemRemoved;
};

export { useTrackWhishlistItemRemoved };
